import React from 'react';
import { BsQuestionCircle } from 'react-icons/bs';
import TooltipWrapper from '../../../components/TooltipWrapper';
import { Placement } from 'react-bootstrap/esm/types';

interface HelpTooltipProps {
  text: string;
  placement?: Placement;
  size?: number;
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ text, placement = 'top', size = 13 }) => (
  <TooltipWrapper tooltipContent={text} tooltipPlacement={placement}>
    <BsQuestionCircle
      style={{
        marginLeft: '4px',
        color: '#6c757d',
        cursor: 'help',
        fontSize: `${size}px`,
        verticalAlign: 'middle'
      }}
    />
  </TooltipWrapper>
);

export default HelpTooltip;
